import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const enableAiExchangeAgent = {
  name: "enableAiExchangeAgent" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
